// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fullscreen-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.88389 5.88387L9 8.99999M9 5H5V9M5.88386 18.1161L8.99998 15M5 15L5 19H9M18.1161 5.88387L15 8.99999M15 5H19V9M18.1161 18.1161L15 15M19 15V19H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fullscreen2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fullscreen-2',
    ref,
    icon: element,
  },
));

Fullscreen2Icon.displayName = 'Fullscreen2Icon';

export default Fullscreen2Icon;
